import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CpCompanyAdhesionService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }

  createCompany(body: any) {
   const contract = atob(sessionStorage.getItem('contract')!)
    const url: string = this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/companies/subscription';
    return this.http.post<any>(url, body);
  }
}
